import { useState, useEffect, useCallback } from "react";
import { Edit } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";
import { api } from "./adminApi";

const TEMPLATE_LABELS = {
  welcome: "Bienvenue / Inscription",
  password_reset: "Réinitialisation mot de passe",
  new_offer: "Nouvelle offre",
  relance: "Relance candidat inactif",
  mission_confirmation: "Confirmation de mission",
  admin_new_registration: "Notification admin (nouvel inscrit)",
};

export default function TemplatesTab() {
  const [templates, setTemplates] = useState([]);
  const [editTemplate, setEditTemplate] = useState(null);
  const [form, setForm] = useState({ subject: "", body: "" });

  const fetchTemplates = useCallback(async () => { try { const r = await api.get("/email-templates"); setTemplates(r.data); } catch {} }, []);
  useEffect(() => { fetchTemplates(); }, [fetchTemplates]);

  const openEdit = (t) => { setEditTemplate(t); setForm({ subject: t.subject, body: t.body }); };

  const handleSave = async () => {
    try {
      await api.put(`/email-templates/${editTemplate.template_key}`, form);
      toast.success("Template sauvegardé");
      setEditTemplate(null); fetchTemplates();
    } catch { toast.error("Erreur"); }
  };

  return (
    <div>
      <p className="text-sm text-gray-500 mb-4">Personnalisez les templates d'emails. Variables disponibles : {"{name}"}, {"{agency_name}"}, {"{code}"}, {"{title}"}, {"{location}"}, {"{mission_title}"}, {"{mission_location}"}, {"{mission_start}"}</p>
      <div className="space-y-3">
        {templates.map((t) => (
          <div key={t.template_key} className="bg-white border border-gray-200 p-4 flex items-center justify-between gap-4" data-testid={`template-${t.template_key}`}>
            <div className="min-w-0 flex-1">
              <h3 className="text-sm font-bold text-[#3F3F3F]">{TEMPLATE_LABELS[t.template_key] || t.template_key}</h3>
              <p className="text-xs text-gray-500 truncate">Sujet : {t.subject}</p>
            </div>
            <button onClick={() => openEdit(t)} className="p-2 hover:bg-gray-100 text-[#0069B4]" data-testid={`edit-template-${t.template_key}`}><Edit className="w-4 h-4" /></button>
          </div>
        ))}
      </div>

      <Dialog open={!!editTemplate} onOpenChange={() => setEditTemplate(null)}>
        <DialogContent className="sm:max-w-xl rounded-none max-h-[90vh] overflow-y-auto">
          <DialogHeader><DialogTitle className="text-[#3F3F3F]">Modifier le template : {editTemplate && (TEMPLATE_LABELS[editTemplate.template_key] || editTemplate.template_key)}</DialogTitle></DialogHeader>
          <div className="space-y-4 mt-4">
            <div><Label className="text-sm font-semibold mb-1 block">Sujet</Label><Input value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="rounded-none" data-testid="template-subject" /></div>
            <div><Label className="text-sm font-semibold mb-1 block">Contenu (texte)</Label><Textarea value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} className="rounded-none min-h-[150px]" data-testid="template-body" /></div>
            <div className="flex gap-3">
              <Button onClick={handleSave} className="bg-gradient-to-r from-[#662483] to-[#0069B4] text-white rounded-none font-semibold" data-testid="save-template-btn">Sauvegarder</Button>
              <Button variant="outline" onClick={() => setEditTemplate(null)} className="rounded-none">Annuler</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
